import ClipboardJS from 'clipboard';
import 'tippy.js/dist/tippy.css';
import tippy from 'tippy.js';

//TODO DE делаю быстро, по хорошему добавить конфиги и избавить от магических чисел
class ClipboardManager {
    constructor() {
        this.initClipboard();
    }

    initClipboard() {
        if (typeof ClipboardJS !== 'undefined') {
            const clipboard = new ClipboardJS('[data-js-clipboard]',{
                text: function(trigger) {
                    if (trigger.hasAttribute('data-callibri_email')) {
                        return trigger.getAttribute('data-callibri_email');
                    }
                    return trigger.getAttribute('data-clipboard-text');
                }
            });
            clipboard.on('success', (e) => {
                this.showNotification('Скопировано!', e.trigger);
                e.clearSelection();
            });
            clipboard.on('error', (e) => {
                console.error('Failed to copy text');
                this.showNotification('Не скопировано!', e.trigger);
            });
        } else {
            console.error('ClipboardJS is not loaded');
        }
    }

    showNotification(message, button) {
        const existingTippy = button._tippy;
        if (existingTippy) {
            existingTippy.destroy();
        }
        const tippyInstance = tippy(button, {
            content: message,
            placement: 'bottom',
            trigger: 'manual',
            arrow: true,
            theme: 'light',
            duration: [300, 300],
            hideOnClick: false,
        })
        tippyInstance.show()
        setTimeout(() => {
            if (tippyInstance) {
                tippyInstance.hide();
            }
        }, 2000);
    }
}

export default ClipboardManager;
